var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
      staticClass: "text-sm",
    },
    [
      _c("MessageControl", {
        attrs: {
          "approved-message-list-url": _vm.approvedMessageListUrl,
          "can-send-approved-sms": _vm.canSendApprovedMessage,
          "can-send-sms": _vm.canSendMessage,
        },
        scopedSlots: _vm._u([
          {
            key: "attachments",
            fn: function () {
              return [
                _c("attachment-list", {
                  staticClass: "px-2 w-100",
                  model: {
                    value: _vm.form.media,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "media", $$v)
                    },
                    expression: "form.media",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "bottom-left-tools-after",
            fn: function () {
              return [
                _c(
                  "ToolButton",
                  {
                    attrs: {
                      disabled: _vm.isAttachMediaButtonDisabled,
                      title: "Add attachments",
                    },
                    on: { click: _vm.openAttachmentDialog },
                  },
                  [_c("i", { staticClass: "fas fa-paperclip fa-fw" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "bottom-right-tools",
            fn: function () {
              return [
                _c(
                  "el-dropdown",
                  {
                    staticClass: "send-button",
                    attrs: {
                      disabled: !_vm.canSend,
                      "split-button": "",
                      size: "medium",
                      title: "Send message",
                    },
                    on: { click: _vm.send, command: _vm.handleSendMenuCommand },
                    scopedSlots: _vm._u([
                      {
                        key: "dropdown",
                        fn: function () {
                          return [
                            _c(
                              "el-dropdown-menu",
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { disabled: "" } },
                                  [_vm._v("Schedule message")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    staticClass: "mb-2",
                                    attrs: {
                                      command: "custom-time",
                                      divided: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Custom time\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [_c("i", { staticClass: "fas fa-paper-plane fa-fw" })]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.form.message,
          callback: function ($$v) {
            _vm.$set(_vm.form, "message", $$v)
          },
          expression: "form.message",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }